import { Box, Button,styled, TextField, Typography } from "@mui/material";






export const HeadingText=styled(Typography)((props)=>(
    {

        // fontSize:props.theme.typography.h1.fontSize,
        fontWeight:"800",
        position:"relative",
        textAlign:"center",
        '&:before':{
            content:`'${props.text}'`,
            position:"absolute",
            fontSize:"200%",
            color:props.theme.palette.shade.main,
            opacity: 0.3,
            left:"0",
            top:"-50%",
            width:"100%",
            height:"100%",
            zIndex:"-1000"
            
        }     
    }
))

export const Btn1=styled(Button)(({theme})=>({
        backgroundColor:"transparent",
        fontWeight:"550",
        fontSize:"1.08rem",
        color:theme.palette.text.primary ,
        textTransform:"capitalize",
        position: "relative",
        '&:hover':{
            backgroundColor:"transparent",
            color:theme.palette.primary.main,
            transition:"color 0.35s ease-out",
        },
        '&:after':{
            content:"''",
            position: "absolute",
            width: "100%",
            height: "2px",
            bottom: "0",
            left: "0",
            backgroundColor:theme.palette.primary.main,
            transform: "scale(0)",
            transition: "transform 0.35s ease-out"
        },
        '&:hover:after':{
            transform:"scale(1)",
        },
        '&:focus':{
            backgroundColor:"transparent",
            color:theme.palette.primary.main,
        },
    }
))

export const Btn2=styled(Button)(({theme})=>(
    {
        backgroundColor:"transparent",
        color:theme.palette.text.primary,
        border:`2px solid ${theme.palette.primary.main}`,
        borderRadius:"25px",
        fontWeight:"550",
        fontSize:"1.08rem",
        padding:"5px 35px",
        textTransform:"capitalize",
        position: "relative",
        overflow:"hidden",
         zIndex:"0",
        '&:after':{
            content:"''",
            position: "absolute",
            width: "100%",
            height: "0px",
            // borderRadius:"25px",
            bottom: "0",
            left: "0",
            backgroundColor:`${theme.palette.primary.main}`,
            // transform: "scale(0)",
            transition: "height 0.25s linear",
            transformOrigin:"bottom",
            zIndex:"-1"
        },
        '&:hover:after':{
            transform:"scale(1)",
            height:"100%",

        }
    }
))




export const RedTypography=styled(Typography)(({theme})=>(
    {
        color:theme.palette.primary.main,
    }
))
export const GreenTypography=styled(Typography)(({theme})=>(
    {
        color:theme.palette.primary.main,
    }
))


export const Circle=styled(Box)(({theme})=>(
    {
        display:"flex",
        justifyContent:"center",
        alignItems:"center",
        color:"text.primary",
        width:"90px",
        height:"90px",
        // border:"1px solid red",
        borderRadius:"100%",
        boxShadow:`
            3px 3px 5px ${theme.palette.primary.main},
            -3px 3px 5px ${theme.palette.secondary.main},
            3px -3px 5px ${theme.palette.tertiary.main}
            
        `,
        transition:"all 0.3s ease-out",
    }
))

export const MyTextField = styled(TextField)(({theme})=>({
    '& input': {
      color: theme.palette.text.primary,
      
    },
    '& label.Mui-focused': {
      color: theme.palette.text.primary,
    },
    '& label': {
      color: theme.palette.shade.light,
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: theme.palette.text.primary,
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: theme.palette.shade.light,
        borderRadius: "10px",
      },
      '&:hover fieldset': {
        borderColor: theme.palette.text.primary,
      },
      '&.Mui-focused fieldset': {
        borderColor: theme.palette.text.primary,
      },
    },
    '&.Mui-error': {
      '& fieldset': {
        borderColor: "red",
      },
      '& label': {
        color: "red",
      },
      '& input': {
        color: "red",
      },
    },
  }));


